// extracted by mini-css-extract-plugin
var _1 = "CollaboratorsPageStyles-module__collaborators-page___oQj7t";
var _2 = "CollaboratorsPageStyles-module__collaborators-page-container___SnrAz";
var _3 = "CollaboratorsPageStyles-module__collaborators-page___oQj7t";
var _4 = "CollaboratorsPageStyles-module__collaborators-page-container___SnrAz";
var _5 = "CollaboratorsPageStyles-module__organizational-error___BnARp";
var _6 = "CollaboratorsPageStyles-module__organizational-error___BnARp";
export { _1 as "collaborators-page", _2 as "collaborators-page-container", _3 as "collaboratorsPage", _4 as "collaboratorsPageContainer", _5 as "organizational-error", _6 as "organizationalError" }
